import React from 'react';

export default () => (
  <svg
    focusable='false'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M7 1.875A5.125 5.125 0 0 1 12.125 7v2.375h7.75a2.25 2.25 0 0 1 2.25 2.25v8.25a2.25 2.25 0 0 1-2.25 2.25H9.125a2.25 2.25 0 0 1-2.25-2.25v-8.25a2.25 2.25 0 0 1 2.25-2.25h1.5V7c0-1.937-1.52-3.52-3.432-3.62L7 3.375A3.625 3.625 0 0 0 3.375 7v3.125a.75.75 0 1 1-1.5 0V7A5.125 5.125 0 0 1 7 1.875zm12.875 9H9.125a.75.75 0 0 0-.75.75v8.25c0 .414.336.75.75.75h10.75a.75.75 0 0 0 .75-.75v-8.25a.75.75 0 0 0-.75-.75zM14.5 13.75a.75.75 0 0 1 .75.75V17a.75.75 0 1 1-1.5 0v-2.5a.75.75 0 0 1 .75-.75z' />
  </svg>
);
